export const formatCurrency = (
  value: number,
  withDecimal = false,
  currency: Intl.NumberFormatOptions['currency'] = 'USD'
) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: withDecimal ? 2 : 0,
    maximumFractionDigits: withDecimal ? 2 : 0,
  }).format(value);
};

export const formatCurrencyCompact = (
  value: number,
  currency: Intl.NumberFormatOptions['currency'] = 'USD'
): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    notation: 'compact',
    maximumFractionDigits: 2,
  }).format(value);
};
